import { Modal } from 'antd';
import logger from '../../services/logger';

const InfoModal = ({ data }) => {
  Modal.info({
    title: data.modalTitle,
    content: data.modalContent,
    width: data.width,
  });
};

const SuccessModal = ({ data }) => {
  Modal.success({
    title: data.modalTitle,
    content: data.modalContent,
    width: data.width,
  });
};

const ErrorModal = ({ data }) => {
  Modal.error({
    title: data.modalTitle,
    content: data.modalContent,
    width: data.width,
    icon: data.icon,
  });
};

const WarningModal = ({ data }) => {
  Modal.warning({
    title: data.modalTitle,
    content: data.modalContent,
    width: data.width,
  });
};

const ConfirmModal = ({ data }) => {
  Modal.confirm({
    title: data.modalTitle,
    content: data.modalContent,
    width: data.width,
    icon: data.icon,
    onOk() {
      return data?.okEvent();
    },
    onCancel() {
      logger.info('Cancel');
    },
  });
};

export { InfoModal, SuccessModal, ErrorModal, WarningModal, ConfirmModal };
